import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import '../styles/NavBar.css';

const NavBar = () => {
    const { user } = useAuth();
    const location = useLocation();

    // Helper function to check if a link is active
    const isActive = (path) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };

    return (
        <nav className="navbar">
            <div className="navbar-content">
                <div className="nav-links">
                    {user ? (
                        <>
                            <Link 
                                to="/my-recipes" 
                                className={`nav-link ${isActive('/my-recipes') ? 'active' : ''}`}
                            >
                                My Recipes
                            </Link>
                            <Link 
                                to="/explore" 
                                className={`nav-link ${isActive('/explore') ? 'active' : ''}`}
                            >
                                Explore
                            </Link>
                            <Link 
                                to="/quiz" 
                                className={`nav-link ${isActive('/quiz') ? 'active' : ''}`}
                            >
                                Recipe Quiz
                            </Link>
                        </>
                    ) : (
                        <>
                            <Link 
                                to="/explore" 
                                className={`nav-link ${isActive('/explore') ? 'active' : ''}`}
                            >
                                Explore
                            </Link>
                            <Link 
                                to="/quiz" 
                                className={`nav-link ${isActive('/quiz') ? 'active' : ''}`}
                            >
                                Recipe Quiz
                            </Link>
                            <Link 
                                to="/login" 
                                className={`nav-link ${isActive('/login') ? 'active' : ''}`}
                            >
                                Login
                            </Link>
                            <Link 
                                to="/register" 
                                className={`nav-link ${isActive('/register') ? 'active' : ''}`}
                            >
                                Register
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default NavBar;